<template>
	<div id="pagina-browsernaosuportado-page">
    <br />
    <br />
		<div id="pagina-browsernaosuportado-container">
			<div id="pagina-browsernaosuportado-container-titulo-oops">
				<div class="display-4 text-danger" style="text-align: center">
					<i class="far fa-sad-tear"></i>
				</div>
				<div id="pagina-browsernaosuportado-titulo-oops" class="text-danger">Oops, seu navegador de internet não é compatível!</div>
				<div id="pagina-browsernaosuportado-titulo-msg" class="px-2">Por favor, utilize um navegador de internet mais recente.</div>
			</div>
		</div>

		<div id="pagina-browsernaosuportado-page-container">
			<div id="pagina-browsernaosuportado-container-nome-app">
				<div id="pagina-browsernaosuportado-nome-app-linxmicrovix">Linx Microvix</div>
				<div id="pagina-browsernaosuportado-nome-app-vendafacil">{{ nomeAplicacao }}</div>
			</div>
		</div>
	</div>
</template>

<script>
//import { mapState } from 'vuex';

export default {
	name: 'BrowserNaoSuportado',

	computed: {
		nomeAplicacao() {
			return "Agenda"; //process.env.VUE_APP_NOME_APLICACAO;
		}
	}
};
</script>

<style scoped>
#pagina-browsernaosuportado-page {
	height: 98vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

#pagina-browsernaosuportado-container {
	flex-grow: 9;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}

#pagina-browsernaosuportado-container-titulo-oops {
	flex-grow: 1;
	text-align: right;
}

#pagina-browsernaosuportado-titulo-oops {
	font-size: 4rem !important;
	font-weight: bolder;
	font-family: Dosis, sans-serif;
	color: #5b2e90;
	text-align: center;
	margin-top: -30px !important;
}

#pagina-browsernaosuportado-container-titulo-msg {
	flex-grow: 1;
	text-align: left;
	text-align: center;
}

#pagina-browsernaosuportado-titulo-msg {
	font-size: 1.5rem !important;
	font-family: Dosis, sans-serif;
	color: #5b2e90;
	text-align: center;
}

#pagina-browsernaosuportado-nome-app-linxmicrovix {
	text-align: center;
	font-family: Dosis, sans-serif;
	font-size: 2rem;
	color: #ffb200;
}

#pagina-browsernaosuportado-nome-app-vendafacil {
	text-align: center;
	font-family: Dosis, sans-serif;
	font-weight: bold;
	font-size: 2rem;
	color: #5b2e90;
}

.btn {
	line-height: 1.5 !important;
}

#btn-sair {
	width: 200px;
	position: relative;
}

@media only screen and (max-width: 600px) {
	#btn-sair {
		display: block !important;
		width: 100% !important;
	}
}
</style>
